var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('main-menu-bar'),_vm._v(" "),_c('div',{staticClass:"page-inner"},[_c('p',[_vm._v("Ontime")]),_vm._v(" "),_c('ontime-timer',{attrs:{"url":_vm.ontimeUrl,"config":{
          onEnd: 'showNegative'
      }}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20f7ca04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ontime/OntimeScreen.vue
// module id = null
// module chunks = 